"use client";
import { cookieName, cookieDefaultLangName, languages, cookieLangListName, fallbackLng } from "../i18n/settings";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { setCookie, getCookie } from "cookies-next";
import { usePathname } from "next/navigation";


export default function ContentLanguageVerification({
    children,
    contentLanguage
}: {
    children: React.ReactNode;
    contentLanguage: string[];
}) {

    const pathName = usePathname();
    const searchParams = useSearchParams();
    const defaultLang = contentLanguage[0];
    const [isClient, setIsClient] = useState(false);
    const [localContentLanguage, setLocalContentLanguage] = useState(contentLanguage);

    // Client-side rendering detection
    useEffect(() => {
        setIsClient(true);
    }, []);

    // Sync local content language with props
    useEffect(() => {
        setLocalContentLanguage(contentLanguage);
    }, [contentLanguage]);

    // Handle client-side actions based on language
    useEffect(() => {
        if (!isClient) return;

        const cookieDefaultLang = getCookie(cookieDefaultLangName);
        const cookieSelectedLang = getCookie(cookieName);
        const cookieLangList = getCookie(cookieLangListName);
        if (cookieDefaultLang == null || cookieDefaultLang !== defaultLang || cookieLangList !== contentLanguage.join(",")) {
            setCookie(cookieDefaultLangName, defaultLang);
            setCookie(cookieLangListName, contentLanguage.join(","));
        }
        if (cookieSelectedLang == null) {
            setCookie(cookieName, defaultLang);
        }

    }, [isClient, pathName, searchParams, defaultLang, localContentLanguage]);

    return <>{children}</>;
}